module.exports = __webpack_public_path__ + "static/media/sm.3404df4b.svg";